function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M5.08 22.958a8.887 8.887 0 006.62-1.884c-1.914-.036-3.594-1.304-4.18-3.156.67.132 1.362.105 2.02-.078-2.087-.428-3.588-2.291-3.589-4.455v-.057a4.387 4.387 0 002.03.568C6.017 12.563 5.41 9.906 6.598 7.83a12.635 12.635 0 009.22 4.749c-.458-2.003.464-4.07 2.248-5.04a4.427 4.427 0 015.375.895 8.88 8.88 0 002.84-1.103 4.549 4.549 0 01-1.966 2.513 8.82 8.82 0 002.57-.715 9.184 9.184 0 01-2.233 2.353c.013.195.013.39.013.587 0 6.006-4.5 12.932-12.728 12.932-5.485 0-7.771-.68-6.857-2.042z",
  stroke: "#000",
  strokeWidth: 1.6,
  fill: "none",
  fillRule: "evenodd",
  strokeLinejoin: "round"
});

function SvgUiTwitter32(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32"
  }, props), _ref);
}

export default SvgUiTwitter32;